import React from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import configureStore, { history } from './redux/store';
import { Route, Switch } from 'react-router';
import ThemeDesign from './pages/v2/ThemeDesign';

const store = configureStore(/ provide initial state if any /);

const NextApp = () => {
  return <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route component={ThemeDesign} />
      </Switch>
    </ConnectedRouter>
  </Provider>;
};
export default NextApp;
